module.exports = __webpack_public_path__ + "media/images/img-icon-99b4bf16fd10cea4f454faa88d76f49c.png";